import { render, staticRenderFns } from "./feedbackedit.vue?vue&type=template&id=00a51086&scoped=true"
import script from "./feedbackedit.vue?vue&type=script&lang=js"
export * from "./feedbackedit.vue?vue&type=script&lang=js"
import style0 from "./feedbackedit.vue?vue&type=style&index=0&id=00a51086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a51086",
  null
  
)

export default component.exports